export default __webpack_public_path__ + "static/home_page_visualization-c9d63f57dff8063df1e730137e476b84.webm";